import {
  AnyRoute,
  createRoute // redirect
} from '@tanstack/react-router'

import CrbMonitorWrapper from './CrbMonitorWrapper'
import { crbMonitorListRoute } from './routes'

export const bankCrbMonitorRoute = <T extends AnyRoute>(rootRoute: T) => {
  const bankCrbMonitorIndexRoute = createRoute({
    getParentRoute: () => rootRoute,
    // TODO move route to commons
    path: '/crb-monitor',
    component: CrbMonitorWrapper
  })

  return bankCrbMonitorIndexRoute.addChildren([crbMonitorListRoute(bankCrbMonitorIndexRoute)])
}
